import React from 'react'

import SelectField from '~/components/Fields/SelectField'

import { DIGITAL, PHYSICAL, PRODUCT_TYPE_NAMES, SERVICE } from '../../constants'

export const options = [
  { value: DIGITAL, name: PRODUCT_TYPE_NAMES[DIGITAL] },
  { value: PHYSICAL, name: PRODUCT_TYPE_NAMES[PHYSICAL] },
  { value: SERVICE, name: PRODUCT_TYPE_NAMES[SERVICE] }
]
function ProductTypeField ({ ...props }) {
  return (
    <SelectField
      name="type"
      data-cy="type"
      label="Type"
      options={options}
      {...props}
    />
  )
}

export default ProductTypeField
